import React, {useState} from 'react';
import classnames from 'classnames';
import {Trans} from 'react-i18next';
import smbUtils from '../../../utils/smbUtils';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';

const SolutionTypeSwitch = ({
  accountServices,
  isTechnicalSupport,
  width,
  customer,
  searchCustomer,
  filterServices,
  switchCustomer,
}) => {
  const [show, setShow] = useState(false);
  const functionType = _get(customer, 'functionType');

  if (
    !functionType ||
    _isEmpty(accountServices) ||
    accountServices.length === 0
  )
    return <div />;

  return (
    <div className="kt-header__topbar-item" style={{position: 'relative'}}>
      <div
        className="kt-header__topbar-wrapper pf-header-user-wrapper"
        onClick={() => {
          (accountServices.length > 1 || isTechnicalSupport) && setShow(!show);
        }}
      >
        <div className="pf-header-user-info">
          <img
            alt=""
            src={
              width > 600
                ? require(`../../../assets/images/account/${functionType}.png`)
                : require(`../../../assets/images/account/sub_menu_${functionType.toLowerCase()}_black.png`)
            }
          />
          <div className="kt-hidden-mobile pl-2">
            <div
              style={{
                whiteSpace: 'nowrap',
                color: '#a7abc3',
              }}
            >
              {smbUtils.getFunctionTypeI18n(functionType)}
            </div>
            <div>{customer.customerName}</div>
          </div>
          {(accountServices.length > 1 || isTechnicalSupport) && (
            <div className="d-flex align-items-center pl-2 kt-hidden-mobile">
              <i className="fa fa-caret-down" />
            </div>
          )}
        </div>
      </div>
      {(accountServices.length > 1 || isTechnicalSupport) && (
        <div
          className={classnames({
            'dropdown-menu': true,
            'dropdown-menu-right': true,
            'dropdown-menu-fit': true,
            'dropdown-menu-anim': true,
            'dropdown-menu-top-unround': true,
            'header-help__dropdown': true,
            show: show,
          })}
          style={{left: 0, width: 'min-content', maxHeight: '80vh'}}
        >
          <div />
          <div className="up" />
          <ul className="kt-nav kt-margin-t-10 kt-margin-b-10">
            <li className="kt-nav__section kt-nav__section--first">
              <span className="kt-nav__section-text">
                <Trans i18nKey="c.l.h.select.account">SELECT ACCOUNT</Trans>
              </span>
            </li>
            <div
              style={{
                fontSize: '1.2rem',
                padding: '0 1.75rem',
                fontWeight: 500,
              }}
            >
              <input
                type="text"
                className="kt-margin-t-10 kt-margin-b-10 form-control"
                onChange={e => searchCustomer(e.target.value)}
                placeholder="Search by email or account name"
              />
            </div>
            {filterServices.map((c, i) => (
              <li className="kt-nav__item" key={`functionType-option${i}`}>
                <a
                  href="#"
                  onClick={() => switchCustomer(c.id)}
                  className="kt-nav__link"
                >
                  <span className="kt-nav__link-icon kt-margin-r-10">
                    <div
                      className={classnames({
                        [`${c.functionType.toLowerCase()}-icon`]: true,
                        [`${c.functionType.toLowerCase()}-icon--active`]:
                          customer.id === c.id,
                      })}
                    />
                  </span>
                  <span
                    className="kt-nav__link-text"
                    style={{color: customer.id === c.id && '#5867dd'}}
                  >
                    <div className="d-flex" style={{flexDirection: 'column'}}>
                      <div>{smbUtils.getFunctionTypeI18n(c.functionType)}</div>
                      <div className="font-weight-bold">{c.customerName}</div>
                      <div>{c.contactEmail}</div>
                    </div>
                  </span>
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default SolutionTypeSwitch;
